import { Grid, Grow, IconButton, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import { Form } from "../../../../layout";
import { CloseRounded, PersonRounded } from "@mui/icons-material";
import { Button, InputPass } from "../../../../controls";
import { useAppContext } from "context";
import { action, API, controller } from "../../../../api/api";
import { ToFormData } from "../../../../hooks/Method";
import { userDisplayName } from "../../../../utils";

const VerifyWithPassword = ({
  values,
  errors,
  setErrors,
  handleInpChg,
  handleClose,
  setStep,
  setSnackbar,
}) => {
  const { setAuthUser } = useAppContext();
  const [errMsg, setErrMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    let temp = {};
    // Validates the id, not the email. Auth/SwitchUser authenticates on Id +
    // password and never looks at the address — but this required one, so every
    // account without an email on file (most staff here) could not be switched to
    // even after being selected.
    temp.password = values.password !== "" ? "" : "Password is required.";
    setErrors({ ...temp });
    return !!values.id && Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        if (res) {
          switch (res.status) {
            case 403:
              setErrors({
                ...errors,
                [res.error.key]: res.error.msg,
              });
              break;
            case 401:
              setErrMsg(res.msg);
              break;
            case 200:
              var result = res.result;
              if (result && result.id) {
                setAuthUser({ ...result });

                handleClose();
                setSnackbar({
                  show: true,
                  type: "success",
                  msg: `Switched to user "${userDisplayName(result)}${
                    result.email ? ` (${result.email})` : ""
                  }"`,
                });
              }

              break;
            default:
              break;
          }
        }
        setLoading(false);
      };
      API(controller.Auth + action.SwitchUser).post(
        ToFormData(values),
        onComplete
      );
    }
  };

  const handleBack = () => {
    setStep(1);
  };

  return (
    <div style={{ maxWidth: "400px" }}>
      <Grow in={true}>
        <Paper className="p-15 bs-primaryMD">
          <Form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div className="text-right">
                  <IconButton size="small" onClick={handleClose}>
                    <CloseRounded />
                  </IconButton>
                </div>

                <div className="flex flex-col items-center gap-4 ">
                  {values.photo ? (
                    <div>
                      <img
                        alt="user_image"
                        src={values.photo}
                        className="h-[100px] w-[100px] rounded-full object-cover"
                      />
                    </div>
                  ) : (
                    <div
                      className="w-fit p-5"
                      style={{
                        backgroundColor: "var(--primaryXS-color)",
                        borderRadius: "50%",
                      }}
                    >
                      <PersonRounded
                        className="primary-color"
                        sx={{ fontSize: "80px" }}
                      />
                    </div>
                  )}
                  <div className="grid text-center">
                    <span className="text-[24px] font-medium text-gray-500">
                      {values.name}
                    </span>
                    <span className="text-primary">{values.email}</span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} className="tx-center">
                <Typography color="error">{errMsg}</Typography>
              </Grid>
              <Grid item xs={12}>
                <InputPass
                  label="Password"
                  name="password"
                  value={values.password}
                  error={errors.password}
                  onChange={handleInpChg}
                  className="input-primary w-100pr"
                />
              </Grid>
              <Grid item xs={12}>
                <div className="grid gap-3">
                  <Button
                    loading={loading}
                    type="submit"
                    fullWidth
                    size="large"
                  >
                    Switch user
                  </Button>
                  <Button
                    type="submit"
                    fullWidth
                    size="large"
                    variant="text"
                    onClick={handleBack}
                  >
                    Chose another user
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Form>
        </Paper>
      </Grow>
    </div>
  );
};

export default VerifyWithPassword;
